import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Input, Signal, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'lib-rows-separators-and-time-indicator',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './rows-separators-and-time-indicator.component.html',
  styleUrls: ['./rows-separators-and-time-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RowsSeparatorsAndTimeIndicatorComponent {
  @Input({ required: true }) public hours!: number[];
  @Input({ required: true }) public intervalCount!: number;
  @Input({ required: true }) public showcaseScrollStartHour!: number;
  @Input({ required: true }) public defaultStartHour!: number;
  @Input({ required: true }) public currentTimeWithTimeZone!: Signal<{ hour: number; minute: number }>;
  @Input({ required: true }) public isToday!: boolean;
  @Input({ required: true }) public timePassedOfHourInPercent$!: Observable<number>;
  @Input({ required: true }) public isShowcase!: boolean;
  @Input({ required: true }) public containerRef!: ElementRef<HTMLDivElement>;

  @ViewChild('timeIndicator', { read: ElementRef, static: false }) public timeIndicator!: ElementRef<HTMLDivElement>;
  @ViewChild('showcaseScrollHour') public showcaseScrollHour!: ElementRef<HTMLDivElement>;
  @ViewChild('defaultScrollHour') public defaultScrollHour!: ElementRef<HTMLDivElement>;

  private scrollToElement(element: ElementRef<HTMLDivElement> | undefined): void {
    const offsetY = 100;
    if (element?.nativeElement && this.containerRef?.nativeElement) {
      const elementRect = element.nativeElement.getBoundingClientRect();
      const containerRect = this.containerRef.nativeElement.getBoundingClientRect();
      const scrollTop = this.containerRef.nativeElement.scrollTop + (elementRect.top - containerRect.top);
      this.containerRef.nativeElement.scrollTo({ top: scrollTop - offsetY, behavior: 'smooth' });
    }
  }

  public scrollToCurrentTime(): void {
    this.scrollToElement(this.timeIndicator);
  }

  public scrollToShowcaseStartHour(): void {
    this.scrollToElement(this.showcaseScrollHour);
  }

  public scrollToDefaultStartHour(): void {
    this.scrollToElement(this.defaultScrollHour);
  }

  /**
   * Scrolls the calendar to the current time or a specific hour based on the provided parameters.
   * @param isToday - A boolean indicating whether to scroll to the current time or not.
   */
  public scrollIntoView(isToday?: boolean): void {
    if (this.isShowcase) {
      this.scrollToShowcaseStartHour();
    } else if (isToday) {
      this.scrollToCurrentTime();
    } else {
      this.scrollToDefaultStartHour();
    }
  }
}
